import type { Channel } from '@types';

import { unstableCachedFetch } from './unstable-cached-fetch';

export async function getChannels() {
  const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;

  const url = `${baseUrl}/api/v2/channels?depth=0&omit=redirects,themeConfig`;

  const headers = new Headers({
    'x-24-org': process.env.NEXT_PUBLIC_API_KEY || '',
  });

  const data = await unstableCachedFetch<Channel[]>({
    headers,
    tags: ['refresh'],
    url,
  });

  return data || null;
}
